import { Routes } from '@angular/router';
import { LayoutComponent } from '@pages/layout/layout.component';
import { authGuard } from '@lib/guards';
import { TermsAndConditionComponent } from '@lib/components/terms-and-condition/terms-and-condition.component';
import { inject } from '@angular/core';
import { AccountsService } from '@lib/services';
import { IAuthResponse } from '@lib/interfaces';
import { subAgentGuard } from '@lib/guards/sub-agent.guard';

export const routes: Routes = [
    {
        path: 'auth/:tenant',
        loadChildren: async () => (await import('@pages/auth')).routes,
        canMatch: [authGuard({ requiresAuthentication: false })],
    },
    {
        path: 'terms-and-condition',
        component: TermsAndConditionComponent,
    },
    {
        path: ':tenant/signup',
        loadChildren: async () => (await import('@pages/signup')).routes,
    },
    {
        path: '',
        component: LayoutComponent,
        canMatch: [authGuard()],
        children: [
            {
                path: 'home',
                loadChildren: async () => (await import('@pages/home')).routes,
            },
            {
                path: 'cash',
                loadChildren: async () => (await import('@pages/cash')).routes,
                resolve: {
                    agentAccountIds: () => {
                        const accountService = inject(AccountsService);
                        const userInfo: IAuthResponse['admin'] = JSON.parse(localStorage.getItem('userInfo') || '');
                        accountService.getAccountsByUserId(userInfo.id).subscribe((response) => {
                            const accountsMap: Map<string, string> = new Map<string, string>();
                            response.data.forEach((account) => {
                                accountsMap.set(account.currencies[0], account.id);
                            });
                            accountService.agentsAccounts.set(accountsMap);
                        });
                    },
                },
            },
            {
                path: 'send-money',
                loadChildren: async () => (await import('@pages/send-money')).routes,
            },
            {
                path: 'location',
                loadChildren: async () => (await import('@pages/location')).routes,
                canActivate: [subAgentGuard],
            },
            {
                path: 'bill-payment',
                loadChildren: async () => (await import('@pages/bill-payment')).routes,
            },
            {
                path: 'cards-listing',
                loadChildren: async () => (await import('@pages/cards-listing')).routes,
            },
            {
                path: 'transaction',
                loadChildren: async () => (await import('@pages/transaction')).routes,
            },
            {
                path: 'user-management',
                loadChildren: async () => (await import('@pages/user-management')).routes,
                canActivate: [subAgentGuard],
            },
            {
                path: 'top-up-info',
                loadChildren: async () => (await import('@pages/top-up-info')).routes,
            },
            {
                path: '**',
                redirectTo: '/home',
                pathMatch: 'full',
            },
        ],
    },
    { path: '**', pathMatch: 'full', redirectTo: '/auth/nymos_api/login' },
];
